import {Component, Input, OnInit} from '@angular/core';
import {MerchantService} from '../services/merchant.service';
import {Contact, Marketday} from '../../entities';
import {ApiService} from '../services/api.service';
import {NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {MerchantContact} from '../../entities/merchant-contact.model';
import {MarketwebsitePreviewMassSmsComponent} from '../marketwebsite-preview-mass-sms/marketwebsite-preview-mass-sms.component';

@Component({
  selector: 'app-send-marketwebsite-preview',
  templateUrl: './send-marketwebsite-preview.component.html',
  styles: []
})
export class SendMarketwebsitePreviewComponent implements OnInit {
  @Input() market: Marketday;
  modalRef: NgbModalRef = null;
  loading: boolean;
  notFoundError: boolean;
  merchantNumber: number;
  contact: Contact;
  previewSend = false;
  lastPreviewLink = null;
  private websiteContacts: MerchantContact[];

  constructor(
    private merchantService: MerchantService,
    private apiService: ApiService,
    public activeModal: NgbActiveModal,
    public modalService: NgbModal
  ) { }

  ngOnInit() {
    this.getPreviewLink();
    this.loadWebsiteContacts().then(
      () => {
        console.log('Finished');
      }
    );
  }

  async searchMerchant() {
    if (!this.merchantNumber) { return; }
    this.contact = null;
    this.previewSend = false;
    const contact = await this.merchantService.searchMerchant(this.merchantNumber)
      .catch((error) => {this.notFoundError = true; this.loading = false; });

    if (contact) {
      this.contact = contact;
      this.notFoundError = false;
    } else {
      this.notFoundError = true;
    }
  }

  sendPreviewLink() {
    this.apiService.post({}, `backoffice/send-merchant-preview-link/${this.market.marketplace.id}/${this.contact.id}`)
      .subscribe({
        next: () => {
          this.previewSend = true;
        },
        error: (err) => console.log(err)
      });
  }

  getPreviewLink() {
    this.apiService.post({}, `backoffice/create-market-website-preview-link/${this.market.marketplace.id}`)
      .subscribe({
        next: (payload) => {
          this.lastPreviewLink = payload._body;
        },
        error: (err) => console.log(err)
      });
  }

  copyPreviewLink(copyinput) {
      copyinput.value = this.lastPreviewLink;
      copyinput.select();
      document.execCommand('copy');
      copyinput.setSelectionRange(0, 0);
  }



  async loadWebsiteContacts() {
    let data = await this.apiService.find(MerchantContact,
      'marketwebsite-contacts-of-last-year-by-marketplace/' + this.market.marketplace.id + '?withPresentationOnly=false').toPromise();
    data = data.filter(c => c.casFunction === 'Inhaber/Geschäftsführer' && c.mobile && c.mobile !== '');
    // Filter duplicates
    data = Array.from(new Set(data.map(a => a.mobile)))
      .map(mobile => {
        return data.find(a => a.mobile === mobile);
      });
    this.websiteContacts = data;
  }


  newMassSms(contacts, recipientType = 'merchantContactPersons', showBranchFilter?, weeks?: number) {
    this.modalRef = this.modalService.open(MarketwebsitePreviewMassSmsComponent, {size: 'lg', backdrop: 'static', windowClass: 'xl'});
    this.modalRef.componentInstance.marketplace = this.market.marketplace;
    this.modalRef.componentInstance.contacts = contacts;
    this.modalRef.componentInstance.recipientType = recipientType;
    this.modalRef.componentInstance.showBranchFilter = showBranchFilter;

    this.modalRef.componentInstance.message = 'Guten Tag, in wenigen Tagen wird Ihr Wochenmarkt in '
      + this.market.keyword
      + ' ganz neu von uns im Internet präsentiert.\n'
      + 'Wir gewähren Ihnen bereits jetzt einen exklusiven Einblick:\n'
      + this.lastPreviewLink + '\n'
      + 'Bitte beachten Sie, dass dieser (Vorschau-) Link eine begrenzte Gültigkeit von 5 Tagen hat.\n'
      + 'Sie haben noch kein persönliches Beschickerprofil angelegt? \n'
      + 'Nutzen Sie die Gelegenheit und registrieren sich jetzt unter https://beschicker.treffpunkt-wochenmarkt.de. '
      + 'Ihre Deutsche Marktgilde eG';
    if (weeks) { this.modalRef.componentInstance.numberOfWeeks = weeks; }
  }

  prepareMassSMS() {
    this.newMassSms(this.merchantService.merchantContactsToContact(this.websiteContacts));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/send-marketwebsite-preview/send-marketwebsite-preview.component.ts